import { render, staticRenderFns } from "./MaterialLookup.vue?vue&type=template&id=1de45a54&"
import script from "./MaterialLookup.js?vue&type=script&lang=js&"
export * from "./MaterialLookup.js?vue&type=script&lang=js&"
import style0 from "./MaterialLookup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports